"use client";

import Image from "next/image";
import Link from "next/link";
import type { Route } from "next";
import { Menu } from "lucide-react";
import { useState, useEffect } from "react";
import type { ComponentType } from "react";
import Button from "../ui/Button";
import "./header.css";

const navLinks = [
  { href: "/", label: "Trang Chủ" },
  { href: "/quy-trinh", label: "Quy Trình" },
  { href: "/doi-ngu", label: "Đội Ngũ" },
  { href: "/bang-gia", label: "Bảng Giá" },
  { href: "/san-pham", label: "Sản phẩm" },
  { href: "/tin-tuc", label: "Tin Tức" },
] satisfies { href: Route; label: string }[];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClient, setIsClient] = useState(false);

  // Đảm bảo chỉ render trên client sau khi mount hoàn toàn
  useEffect(() => {
    setIsClient(true);
  }, []);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="header-container">
      <div className="logo">
        <Link href="/" aria-label="Trang chủ">
          <Image
            src="/assets/sdtc-image/trang-chu/Logo/sdtc.webp"
            alt="Logo SDTC"
            width={180}
            height={70}
            priority
            fetchPriority="high"
          />
        </Link>
      </div>

      <Button
        variant="ghost"
        size="sm"
        className="mobile-menu-btn"
        onClick={toggleMenu}
        aria-label="Mở hoặc đóng menu"
      >
        <Menu size={20} color="#007bff" />
      </Button>

      <nav className="desktop-nav" aria-label="Điều hướng chính">
        <ul className="menu">
          {navLinks.map((link) => (
            <li key={link.href}>
              <Link href={link.href}>{link.label}</Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="advise-btn">
        <Link href="/dat-lich" className="advise-btn">
          <Button variant="primary" size="md">
            Đặt lịch tư vấn
          </Button>
        </Link>
      </div>

      {/* Chỉ render MobileMenu trên client và khi mở để tránh hydration error */}
      {isClient && isMenuOpen && (
        <MobileMenuLazy isOpen={isMenuOpen} onClose={closeMenu} />
      )}
    </header>
  );
}

// Component riêng để lazy load MobileMenu
function MobileMenuLazy({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const [MobileMenuComponent, setMobileMenuComponent] = useState<ComponentType<{ isOpen: boolean; onClose: () => void }> | null>(null);

  useEffect(() => {
    // Dynamic import chỉ trên client
    import("./MobileMenu").then((module) => {
      setMobileMenuComponent(() => module.default);
    });
  }, []);

  if (!MobileMenuComponent) return null;

  return <MobileMenuComponent isOpen={isOpen} onClose={onClose} />;
}
